import * as React from "react"
const WebAppSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 290.6 290.6",
    }}
    viewBox="0 0 290.6 290.6"
    {...props}
  >
    <style>{".st0{fill:#2d2d2d}.st1{fill:#70b4c6}"}</style>
    <path
      d="M257.8 243.8h-23.4c-7.8 0-14.1-6.3-14.1-14.1V84.4h51.6v145.3c0 7.7-6.3 14.1-14.1 14.1zM196.9 243.8h-23.4c-7.8 0-14.1-6.3-14.1-14.1V84.4H211v145.3c-.1 7.7-6.4 14.1-14.1 14.1zM135.9 243.8h-23.4c-7.8 0-14.1-6.3-14.1-14.1V84.4H150v145.3c0 7.7-6.3 14.1-14.1 14.1z"
      className="st0"
    />
    <path
      d="M0 28.1v234.4h290.6V28.1H0zm9.4 9.4h70.3v215.6H9.4V37.5zm271.8 215.6H89.1V37.5h192.2v215.6z"
      className="st1"
    />
    <path
      d="M246.1 98.4c-9 0-16.4 7.4-16.4 16.4s7.4 16.4 16.4 16.4 16.4-7.4 16.4-16.4-7.4-16.4-16.4-16.4zm0 23.5c-3.9 0-7-3.2-7-7 0-3.9 3.2-7 7-7s7 3.2 7 7-3.1 7-7 7zM220.3 192.2h51.6v9.4h-51.6zM248.4 135.9h9.4v46.9h-9.4zM234.4 135.9h9.4v46.9h-9.4zM185.2 98.4c-9 0-16.4 7.4-16.4 16.4s7.4 16.4 16.4 16.4c9 0 16.4-7.4 16.4-16.4s-7.4-16.4-16.4-16.4zm0 23.5c-3.9 0-7-3.2-7-7 0-3.9 3.2-7 7-7 3.9 0 7 3.2 7 7s-3.2 7-7 7zM159.4 192.2H211v9.4h-51.6zM187.5 135.9h9.4v46.9h-9.4zM173.4 135.9h9.4v46.9h-9.4zM124.2 98.4c-9 0-16.4 7.4-16.4 16.4s7.4 16.4 16.4 16.4 16.4-7.4 16.4-16.4-7.3-16.4-16.4-16.4zm0 23.5c-3.9 0-7-3.2-7-7 0-3.9 3.2-7 7-7s7 3.2 7 7-3.1 7-7 7zM98.4 192.2H150v9.4H98.4zM126.6 135.9h9.4v46.9h-9.4zM112.5 135.9h9.4v46.9h-9.4zM18.8 46.9v37.5h51.6V46.9H18.8zM60.9 75H28.1V56.2h32.8V75zM18.8 131.2h51.6V93.8H18.8v37.4zm9.3-28.1h32.8v18.8H28.1v-18.8zM18.8 178.1h51.6v-37.5H18.8v37.5zm9.3-28.1h32.8v18.8H28.1V150zM44.5 187.5c-14.2 0-25.8 11.6-25.8 25.8s11.6 25.8 25.8 25.8 25.8-11.6 25.8-25.8-11.6-25.8-25.8-25.8zm0 42.2c-9 0-16.4-7.4-16.4-16.4s7.4-16.4 16.4-16.4 16.4 7.4 16.4 16.4-7.3 16.4-16.4 16.4zM271.9 46.9H98.4V75h173.4l.1-28.1zm-9.4 18.7H107.8v-9.4h154.7v9.4z"
      className="st1"
    />
  </svg>
)
export default WebAppSvg
